module.exports = __webpack_public_path__ + "media/images/emblems/Gampelen-coat_of_arms-a27d67eb1f3bc981a4ba4c85d5da8255.svg";